
import useDataTable from '@app/useDataTable'


function useDataTableSelectList(name, modelName, api, headers,  options) {

    options = options || {}; 

    // No need for Select list dialogs to be listening to saved / removed events.
    options.noSaveHandler = true;
    options.noRemoveHandler = true;

    return useDataTable(name, modelName, api, headers, options);
}

export default useDataTableSelectList;
